module.exports = __webpack_public_path__ + "static/media/clock.5cfe1fd0.svg";